'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Sidebar = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactAddonsPureRenderMixin = require('react-addons-pure-render-mixin');

var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);

var _reactRedux = require('react-redux');

var _navigation = require('program/frontend/actions/navigation');

var _Drawer = require('material-ui/Drawer');

var _Drawer2 = _interopRequireDefault(_Drawer);

var _List = require('material-ui/List');

var _videoIndex = require('program/video-index.json');

var _videoIndex2 = _interopRequireDefault(_videoIndex);

var _chapter = require('./chapter');

var _video = require('./video');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var styles = {

  drawer: {
    backgroundColor: "#eee"
  }

};

function convertGroup(gr) {

  return gr.map(function (it, idx) {

    if (it.type === "video") {

      return _react2['default'].createElement(_video.Video, {
        key: idx,
        title: it.shortTitle,
        videoId: it.videoId
      });
    }

    if (it.type === "group") {

      return _react2['default'].createElement(
        _chapter.Chapter,
        {
          key: idx,
          title: it.title,
          contents: it.contents
        },
        convertGroup(it.contents)
      );
    }

    return null;
  });
}

var Sidebar = _react2['default'].createClass({

  displayName: "Sidebar",

  mixins: [_reactAddonsPureRenderMixin2['default']],

  handleChange: function handleChange(open) {

    this.props.dispatch((0, _navigation.setOpenSidebar)(open));
  },
  render: function render() {
    var _props = this.props,
        docked = _props.docked,
        open = _props.open;


    return _react2['default'].createElement(
      _Drawer2['default'],
      {
        open: docked || open,
        docked: docked,
        containerStyle: styles.drawer,
        onRequestChange: this.handleChange
      },
      _react2['default'].createElement(
        _List.List,
        null,
        convertGroup(_videoIndex2['default'].root)
      )
    );
  }
});

exports.Sidebar = Sidebar = (0, _reactRedux.connect)(function (state) {
  return {
    docked: state.navigation.dockedSidebar,
    open: state.navigation.openSidebar
  };
})(Sidebar);

exports.Sidebar = Sidebar;


//////////////////
// WEBPACK FOOTER
// ./program/frontend/sidebar/index.jsx
// module id = 944
// module chunks = 0